
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useAlert } from 'react-alert';

const DeleteMedConfirmPopup = (props) => {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            show={true}
        >
            <Modal.Body style={{ alignItems: "center", justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="7em" height="7em" viewBox="0 0 24 24"><path fill="#facea8" d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 17v-2h1v2zm0-4V8h1v5z" /></svg>
                {props.action === "in_stock" ? <h5 style={{ wordWrap: "break-word", wordBreak: " break-word" }} id="">Please confirm if you want to mark this medicine as out of stock.</h5> :
                    props.action === "out_stock" ? <h5 style={{ wordWrap: "break-word", wordBreak: " break-word" }} id="">Please confirm if you want to mark this medicine as in stock.</h5> :
                        props.action === "active" ? <h5 style={{ wordWrap: "break-word", wordBreak: " break-word" }} id="">Please confirm if you want to mark this medicine as not permitted.</h5> :
                            props.action === "inactive" ? <h5 style={{ wordWrap: "break-word", wordBreak: " break-word" }} id="">Please confirm if you want to mark this medicine as permitted.</h5> : 
                            props.action === "promoted" ? <h5 style={{ wordWrap: "break-word", wordBreak: " break-word" }} id="">Please confirm if you want to mark this medicine as unpromoted.</h5> : 
                            props.action === "not_promoted" ? <h5 style={{ wordWrap: "break-word", wordBreak: " break-word" }} id="">Please confirm if you want to mark this medicine as promoted.</h5> : ""}

                <div>
                    <button onClick={() => {
                        props.onHide()
                    }} type="button" className="swal2-cancel swal2-styled swal2-default-outline" aria-label="" style={{ display: "inline-block", borderRadius: "5px", width: "fit-content", backgroundColor: "rgb(220, 53, 69)", color: "white", padding:"5px 20px" }}>Cancel</button>
                    &nbsp;&nbsp;<button onClick={() => {

                        props.onHide()
                        props.handleDelete();
                    }} type="button" className="swal2-confirm swal2-styled swal2-default-outline" aria-label="" style={{ display: "inline-block", borderRadius: "5px", width: "fit-content", backgroundColor: "rgb(43, 105, 163)", color: "white", padding: "5px 20px" }}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export default DeleteMedConfirmPopup